import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";

import ProductIcon from "./ProductIcon";
import ProductDateSupportText from "./ProductDateSupportText";
import ProductPriceSupportText from "./ProductPriceSupportText";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { CityCardDestination } from "typings/microserviceModels/top-cities-flex-module";

const FullBleedImageCityCard = (props: { city: CityCardDestination }) => {
  const { city } = props;
  const { name: cityName, link, deal } = city;
  const mainImage = city.images[0];
  const { formatText } = useLocalization();

  return (
    <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
      <TrackedLink
        moduleName="topCities"
        rfrr="hotelTravelGuideLink"
        href={link}
        data-testid={`top-cities-full-bleed-image-${cityName}`}
      >
        <UitkImage
          src={mainImage.url}
          alt={mainImage.alt}
          placeholderImage={true}
          className="uitk-rounded-border-top uitk-rounded-border-bottom"
        />

        <ProductIcon />

        <UitkScrim className="uitk-rounded-border-bottom">
          <UitkLayoutFlex justifyContent="space-between" alignItems="end">
            <UitkLayoutFlex direction="column">
              <UitkText size={500} weight="bold">
                {cityName}
              </UitkText>

              <ProductDateSupportText deal={deal} />
            </UitkLayoutFlex>

            {deal && (
              <UitkLayoutFlex direction="column" className="uitk-type-right">
                <div
                  className="uitk-type-300"
                  dangerouslySetInnerHTML={{
                    __html: formatText("topCities.productPrice", deal.priceFormatted),
                  }}
                />

                <ProductPriceSupportText />
              </UitkLayoutFlex>
            )}
          </UitkLayoutFlex>
        </UitkScrim>
      </TrackedLink>
    </UitkFigure>
  );
};

export default FullBleedImageCityCard;
